import { config } from "../config.js";

export async function requestBootloaderPort(): Promise<SerialPort | null> {
  try {
    return await navigator.serial.requestPort({
      filters: [config.bootloaderUsbFilter],
    });
  } catch (err) {
    if (err instanceof DOMException && err.name === "NotFoundError") {
      return null;
    }
    throw err;
  }
}

export async function openPort(port: SerialPort): Promise<void> {
  await port.open({
    baudRate: 115200,
    dataBits: 8,
    stopBits: 1,
    parity: "none",
    flowControl: "none",
  });
}

export async function closePort(port: SerialPort): Promise<void> {
  try {
    if (port.readable) {
      const r = port.readable.getReader();
      r.releaseLock();
    }
    if (port.writable) {
      const w = port.writable.getWriter();
      w.releaseLock();
    }
  } catch {
    // ignore lock-release races
  }
  try {
    await port.close();
  } catch {
    // ignore
  }
}
